import {ControllerEventName} from "../../../event-buses/ControllerEventName";

export class AlertControllerEventName extends ControllerEventName {

  static readonly AlertAcknowledged = 'AlertAcknowledged';
}
